import { DateTime } from "luxon";
import { IProject } from "src/app/admin/projects/shared/models/IProject";
import { ITimeEntry } from "./ITimeEntry";

const timeEntryTotalTimeReducer = (total, entry: ITimeEntry) =>
  total + entry.timeSpentMinutes;

export class CalendarDay {
  constructor(
    public date: DateTime,
    public isLocked = false,
    public hasException = false
  ) {}
  get isToday(): boolean {
    return (
      this.date.startOf("day").toMillis() ==
      DateTime.local().startOf("day").toMillis()
    );
  }
  get isWeekend(): boolean {
    if (!this.date) {
      return false;
    }
    return this.date.weekday >= 6;
  }
  get canEdit(): boolean {
    // TODO can edit should be false if in the future
    return !this.isLocked || this.hasException;
  }
}

export class CalendarProject {
  public days: CalendarProjectDay[] = [];
  get totalTime(): number {
    if (!this.days) {
      return 0;
    }
    return this.days.reduce(
      (total, day) =>
        total + day.timeEntries.reduce(timeEntryTotalTimeReducer, 0),
      0
    );
  }
  constructor(public project: IProject, dates: CalendarDay[]) {
    this.days = dates.map((day) => {
      return new CalendarProjectDay(day.date);
    });
  }
}

export class CalendarProjectDay {
  get totalTime(): number {
    if (!this.timeEntries) {
      return 0;
    }
    return this.timeEntries.reduce(timeEntryTotalTimeReducer, 0);
  }
  constructor(public date: DateTime, public timeEntries: ITimeEntry[] = []) {}
}
